/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Personal_Data_DescriptionInputs */

const de_account_personal_data_description = /** @type {(inputs: Account_Personal_Data_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier können Sie Ihre persönlichen Daten einsehen und bearbeiten.`)
};

/** @type {(inputs: Account_Personal_Data_DescriptionInputs) => LocalizedString} */
const en_account_personal_data_description = de_account_personal_data_description;

/**

* @param {Account_Personal_Data_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_personal_data_description = /** @type {((inputs?: Account_Personal_Data_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Personal_Data_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_personal_data_description(inputs)
	return en_account_personal_data_description(inputs)
});